export default {
  isActive(globalAutomation) {
    return globalAutomation.global_automation_configurations !== undefined
      && globalAutomation.global_automation_configurations.data !== undefined
      && globalAutomation.global_automation_configurations.data[0] !== undefined
      && globalAutomation.global_automation_configurations.data[0].active;
  },
  isInactive(globalAutomation) {
    return globalAutomation.global_automation_configurations === undefined
      || (globalAutomation.global_automation_configurations.data !== undefined
        && globalAutomation.global_automation_configurations.data[0] === undefined)
      || (globalAutomation.global_automation_configurations.data !== undefined
        && globalAutomation.global_automation_configurations.data[0] !== undefined
        && globalAutomation.global_automation_configurations.data[0].active === false);
  },
  isOneTimeDataEnrichment(globalAutomation) {
    return globalAutomation.global_automation_configurations !== undefined
      && globalAutomation.global_automation_configurations.data !== undefined
      && globalAutomation.global_automation_configurations.data[0] !== undefined
      && globalAutomation.global_automation_configurations.data[0].type === "data_enrichment"
      && globalAutomation.global_automation_configurations.data[0].run_interval === "once";
  },
};
